import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import PenilaianRepository from '../Repositories/PenilaianRepository'
import { cancelToken } from '../../../../../services/adapters/kepegawaian/penilaian360Service'

class PenilaianBloc
{
    repository = new PenilaianRepository()
    penilaianListChannel = new Subject()
    penilaianDetailChannel = new Subject()
    penilaianComponentChannel = new Subject()
    penilaianDraftChannel = new Subject()
    penilaianFinishChannel = new Subject()
    penilaianBeginChannel = new Subject()

    constructor(){
        this.penilaianListChannel.next({status: apiResponse.INITIAL})
        this.penilaianDetailChannel.next({status: apiResponse.INITIAL})
        this.penilaianComponentChannel.next({status: apiResponse.INITIAL})
        this.penilaianDraftChannel.next({status: apiResponse.INITIAL})
        this.penilaianFinishChannel.next({status: apiResponse.INITIAL})
        this.penilaianBeginChannel.next({status: apiResponse.INITIAL})
    }

    fetchPenilaianList = async (query, cancelToken) => {
        this.penilaianListChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchPenilaianList(query, cancelToken).then((result) => {
            this.penilaianListChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.penilaianListChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchPenilaianDetail = async (query) => {
        this.penilaianDetailChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchPenilaianDetail(query).then((result) => {
            this.penilaianDetailChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.penilaianDetailChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchPenilaianComponent = async (query) => {
        this.penilaianComponentChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchPenilaianComponent(query).then((result) => {
            this.penilaianComponentChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.penilaianComponentChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchSubmitDraft = async (query) => {
        this.penilaianDraftChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchSubmitDraft(query).then((result) => {
            this.penilaianDraftChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.penilaianDraftChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchSubmitFinish = async (query) => {
       this.penilaianFinishChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchSubmitFinish(query).then((result) => {
            this.penilaianFinishChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.penilaianFinishChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchBegin = async (query) => {
       this.penilaianBeginChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchBegin(query).then((result) => {
            this.penilaianBeginChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.penilaianBeginChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

}

export default PenilaianBloc